"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.files = exports.methods = exports.updateBookmark = exports.isDefaultSearch = exports.initialState = exports.initialSortByOptions = exports.defaultFileSearchOptions = void 0;
const fp = require("fp-ts");
const monocle = require("monocle-ts");
const CartActionTypes = require("../../actionTypes/cart");
const ActionTypes = require("../../actionTypes/files");
const FolderPermissionChecksActionTypes = require("../../actionTypes/folders/permissionChecks");
const _revisionsActions = require("../../modules/revisions/actionTypes");
const Types = require("../../types");
const automaticFileConversionReducer = require("./automaticFileConversion");
const fileReportReducer = require("./fileReport");
const permissionReducers = require("./permissionChecks");
const _metaReducer = require("../../modules/metaschema/reducers");
const _listReducer = require("../../modules/files/list/reducers");
const _folderTreeReducer = require("../../modules/files/tree/reducers");
const _propertiesReducer = require("../../modules/files/crud/reducers");
const _previewReducer = require("../../modules/files/preview/reducers");
const Tree_1 = require("../../modules/files/tree/Tree");
const translation_1 = require("../../utils/translation");
const folderTreeReducer = _folderTreeReducer.default('files', 'NO_INHERIT_SELECTION');
const importFromProjectReducer = _folderTreeReducer.default('import', 'INHERIT_SELECTION');
const folderBrowserReducer = _folderTreeReducer.default('browser', 'NO_INHERIT_SELECTION');
const metaReducer = _metaReducer.default('files');
const propertiesReducer = _propertiesReducer.default('files');
const listReducers = _listReducer.default('files');
const quickSearchReducers = _listReducer.default('files-quicksearch');
const previewReducer = _previewReducer.default('files');
const revisionActions = _revisionsActions.default('files');
const NONE = 'NONE';
exports.defaultFileSearchOptions = {
    filtering: NONE,
    toggleShowBookmarks: false,
    toggleHideEmptyFolders: false,
    limitSearchToMetadata: false,
    limitSearchToFolder: fp.option.none,
    searchString: '',
    searchFileType: fp.option.none,
    containsTermString: '',
    toggleRecents: false,
    moreSearch: false,
    meta: null,
    metaValue: null,
    allVersions: false,
    from: null,
    to: null
};
const defaultNotificationsOptionsOverlayStatus = {
    type: Types.CLOSED
};
const STANDBY = 'STANDBY';
const FETCHING = 'FETCHING';
const FETCHED = 'FETCHED';
const FAILED = 'FAILED';
exports.initialSortByOptions = {
    sortBy: 0,
    order: 'asc',
    limit: 350,
    offset: 0,
    filters: {}
};
const fileBrowserInitState = {
    enabled: true,
    tree: Object.assign({}, folderBrowserReducer.initialState),
    widthStatus: STANDBY,
    fileListWidth: 0,
    openStatus: 'CLOSED',
    missingParents: [],
    queue: {},
    lookup: {},
    desiredTarget: null
};
exports.initialState = Object.assign({ searchOptions: Object.assign({}, exports.defaultFileSearchOptions), selectedView: 'DIFF', metadata: Object.assign({}, metaReducer.initialState), data: Object.assign({}, listReducers.initialState), sortByOptions: exports.initialSortByOptions, notificationsOptionsOverlayStatus: defaultNotificationsOptionsOverlayStatus, selectedItems: [], searchData: Object.assign({}, quickSearchReducers.initialState), filtersDropdownToggled: false, columnsDropdownToggled: false, currentFolder: null, folderPath: [], preview: previewReducer.initialState, fileReport: fileReportReducer.initialState, copyOrMove: folderTreeReducer.initialState, fileBrowser: Object.assign({}, fileBrowserInitState), import: {
        currentStep: '1',
        step1: {
            projectList: [],
            files: importFromProjectReducer.initialState
        },
        step2: {
            groupsList: [],
            groups: []
        }
    }, filesFolderProperties: propertiesReducer.initialState, sortDropdownToggled: false, mobileSearchOverlayToggled: false, searchDropdownToggled: false, advancedSearchDropdownToggled: false, previewFileDropdownToggled: false, previewFileRevision: fp.option.none, previewFullScreenEnabled: false, comparedFileRevision: fp.option.none, comparisionOpacity: 1, fileList: {
        columnSearchStrings: {},
        filteredMetadataColumns: []
    }, selectedFolders: [], permissionChecks: Object.assign({}, permissionReducers.initialState) }, automaticFileConversionReducer.initialState);
const isDefaultSearch = (x) => {
    const def = JSON.stringify(exports.defaultFileSearchOptions);
    const cur = JSON.stringify(x);
    return def === cur;
};
exports.isDefaultSearch = isDefaultSearch;
const previewFileRevision = monocle.Lens.fromProp('previewFileRevision');
const comparedFileRevision = monocle.Lens.fromProp('comparedFileRevision');
const selectedItems = monocle.Lens.fromProp('selectedItems');
const searchOptions = monocle.Lens.fromProp('searchOptions');
const metadata = monocle.Lens.fromProp('metadata');
const searchDataLens = monocle.Lens.fromProp('searchData');
const searchDropdownToggledLens = monocle.Lens.fromProp('searchDropdownToggled');
const advancedSearchDropdownToggledLens = monocle.Lens.fromProp('advancedSearchDropdownToggled');
const _searchStringLens = monocle.Lens.fromProp('searchString');
const _containsTermStringLens = monocle.Lens.fromProp('containsTermString');
const _limitSearchToFolder = monocle.Lens.fromProp('limitSearchToFolder');
const _searchFileType = monocle.Lens.fromProp('searchFileType');
const _searchMoreSearch = monocle.Lens.fromProp('moreSearch');
const _toggleHideEmptyFolders = monocle.Lens.fromProp('toggleHideEmptyFolders');
const _toggleShowBookmarks = monocle.Lens.fromProp('toggleShowBookmarks');
const _toggleRecents = monocle.Lens.fromProp('toggleRecents');
const _setFiltering = monocle.Lens.fromProp('filtering');
const searchStringLens = searchOptions.compose(_searchStringLens);
const containsTermStringLens = searchOptions.compose(_containsTermStringLens);
const limitSearchToFolder = searchOptions.compose(_limitSearchToFolder);
const searchFileType = searchOptions.compose(_searchFileType);
const searchMoreSearch = searchOptions.compose(_searchMoreSearch);
const toggleHideEmptyFolders = searchOptions.compose(_toggleHideEmptyFolders);
const toggleShowBookmarks = searchOptions.compose(_toggleShowBookmarks);
const toggleRecents = searchOptions.compose(_toggleRecents);
const setFilteringLens = searchOptions.compose(_setFiltering);
const comparisionOpacity = monocle.Lens.fromProp('comparisionOpacity');
const data = monocle.Lens.fromProp('data');
const _status = monocle.Lens.fromProp('status');
const dataStatus = data.compose(_status);
const currentFolder = monocle.Lens.fromProp('currentFolder');
const folderPath = monocle.Lens.fromProp('folderPath');
const notificationsOptionsOverlayStatus = monocle.Lens.fromProp('notificationsOptionsOverlayStatus');
const sortByOptions = monocle.Lens.fromProp('sortByOptions');
const offsetLens = monocle.Lens.fromProp('offset');
const sortByOptionsFiltersHelper = monocle.Lens.fromProp('filters');
const sortByOptionsFilter = sortByOptions.compose(sortByOptionsFiltersHelper);
const selectedFolders = monocle.Lens.fromProp('selectedFolders');
const initialPermissionsStateLens = monocle.Lens.fromProp('permissionChecks');
const copyOrMoveLens = monocle.Lens.fromProp('copyOrMove');
const importLens = monocle.Lens.fromProp('import');
const importStep1Lens = monocle.Lens.fromProp('step1');
const importStep1FilesLens = monocle.Lens.fromProp('files');
const propertiesLens = monocle.Lens.fromProp('filesFolderProperties');
// FileListState
const fileListLens = monocle.Lens.fromProp('fileList');
// FileBrowserState
const fileBrowserLens = monocle.Lens.fromProp('fileBrowser');
const fileBrowserTreeLens = monocle.Lens.fromProp('tree');
const fileBrowserTreeStateLens = monocle.Lens.fromPath(['fileBrowser', 'tree', 'data', 'tree']);
function updateBookmark(state, bookmarkIds, bookmarkStatus) {
    if (state.data.status === FETCHED) {
        const files = state.data.files.map((file) => {
            if (file.type === 'FOLDER') {
                return bookmarkIds.indexOf(file.id) > -1
                    ? Object.assign(Object.assign({}, file), { bookmarked: bookmarkStatus }) : file;
            }
            else {
                return bookmarkIds.indexOf(file.file) > -1
                    ? Object.assign(Object.assign({}, file), { bookmarked: bookmarkStatus }) : file;
            }
        });
        return Object.assign(Object.assign({}, state), { data: Object.assign(Object.assign({}, state.data), { files: files }) });
    }
    return state;
}
exports.updateBookmark = updateBookmark;
function removeChildsFromLookup(node, lookup) {
    const item = lookup[node.id];
    const childs = item.getChildren();
    for (const child of childs) {
        const raw = child.getValue();
        removeChildsFromLookup(raw, lookup);
        delete lookup[raw.id];
    }
}
function handleFileBrowserChilds(parent, files, lookup, tree) {
    const childs = [...parent.getChildren()].filter((item) => {
        const raw = item.getValue();
        const found = files.findIndex((x) => x.id === raw.id) > -1;
        if (!found) {
            removeChildsFromLookup(raw, lookup);
            delete lookup[raw.id];
            tree.delete(item);
        }
        return found;
    });
    const ids = [];
    for (const item of files) {
        if (item.type !== 'FOLDER') {
            continue;
        }
        let cur = lookup[item.id];
        if (cur) {
            if (cur.getValue().parent !== item.parent) {
                // File has been moved
                const oldParent = cur.getParentNode();
                if (oldParent) {
                    oldParent.deleteChildren(cur);
                    childs.push(cur);
                }
            }
            cur.setValue(item);
        }
        else {
            ids.push(item.id);
            cur = new Tree_1.Node(item, parent.getSelectMode());
            lookup[item.id] = cur;
            childs.push(cur);
        }
    }
    return {
        ids,
        childs
    };
}
function handleQueue(p, ids, tree) {
    let handleIds = ids;
    while (handleIds.length > 0) {
        const id = handleIds.shift();
        if (id === undefined) {
            continue;
        }
        const queue = p.queue[id];
        const parent = p.lookup[id];
        if (queue === undefined || parent === undefined) {
            continue;
        }
        const x = handleFileBrowserChilds(parent, queue, p.lookup, tree);
        handleIds = [...handleIds, ...x.ids];
        parent.setChildren(x.childs);
        parent.sortChildren('asc');
        parent.setLoading(false);
        // delete parent from queue
        delete p.queue[id];
    }
}
function handleFileBrowser(state, node, files, path, selectItem) {
    if (!state.enabled) {
        return state;
    }
    const parent = state.lookup[node.id];
    let lookup = state.lookup;
    let queue = state.queue;
    let tree = state.tree.data.tree;
    let desiredTarget = state.desiredTarget;
    let target = state.tree.target;
    let missingParents = state.missingParents;
    if (tree && parent !== undefined) {
        tree = tree.clone();
        lookup = Object.assign({}, lookup);
        const { ids, childs } = handleFileBrowserChilds(parent, files, lookup, tree);
        const rawParent = parent.getValue();
        if (rawParent.id === rawParent.parent) {
            node.name = rawParent.name;
        }
        parent.setValue(node);
        if (ids.length > 0) {
            // Fake "pointer" thanks javascript ;)
            const pointer = { queue, lookup };
            handleQueue(pointer, ids, tree);
            queue = pointer.queue;
            lookup = pointer.lookup;
        }
        parent.setChildren(childs);
        parent.sortChildren('asc');
        parent.setLoading(false);
        if (selectItem) {
            if (state.tree.target) {
                state.tree.target.setSelected(false);
            }
            parent.setExpanded(true);
            parent.setSelected(true);
            target = parent;
            desiredTarget = null;
            let x = parent;
            while (x) {
                x.setExpanded(true);
                const raw = x.getValue();
                x = raw.id !== raw.parent ? lookup[raw.parent] : undefined;
            }
        }
        else if (desiredTarget !== null) {
            const newTarget = lookup[desiredTarget];
            if (newTarget) {
                if (state.tree.target) {
                    state.tree.target.setSelected(false);
                }
                newTarget.setExpanded(true);
                newTarget.setSelected(true);
                target = newTarget;
                let x = newTarget;
                while (x) {
                    x.setExpanded(true);
                    const raw = x.getValue();
                    x = raw.id !== raw.parent ? lookup[raw.parent] : undefined;
                }
                desiredTarget = null;
            }
        }
    }
    else {
        if (selectItem) {
            desiredTarget = node.id;
        }
        missingParents = [...missingParents, path];
        if (state.tree.target) {
            state.tree.target.setSelected(false);
        }
        const childs = files.filter((x) => x.type === 'FOLDER');
        if (childs.length > 0) {
            queue = Object.assign({}, queue);
            queue[node.id] = childs;
        }
    }
    if (parent) {
        return Object.assign(Object.assign({}, state), { lookup,
            queue,
            desiredTarget, tree: Object.assign(Object.assign({}, state.tree), { target: target, data: Object.assign(Object.assign({}, state.tree.data), { tree }) }) });
    }
    else if (queue !== state.queue || missingParents !== state.missingParents) {
        return Object.assign(Object.assign({}, state), { missingParents,
            queue,
            desiredTarget, tree: Object.assign(Object.assign({}, state.tree), { target: target }) });
    }
    return state;
}
exports.methods = {};
exports.methods[listReducers.ActionTypes.FETCH_REQUEST] = (state, action) => {
    const item = state.fileBrowser.lookup[action.payload.folderId];
    let tree = state.fileBrowser.tree.data.tree;
    if ((0, exports.isDefaultSearch)(Object.assign(Object.assign({}, (action.payload.searchOptions || state.searchOptions)), { toggleHideEmptyFolders: false })) &&
        item &&
        tree) {
        tree = tree.clone();
        item.setLoading(true);
    }
    return fp.function.compose(fileBrowserTreeStateLens.set(tree), dataStatus.set(FETCHING), sortByOptions.compose(offsetLens).set(0), searchOptions.set(action.payload.searchOptions || state.searchOptions), sortByOptions.set(action.payload.sortByOptions || state.sortByOptions), selectedItems.set([]), searchDataLens.set({
        status: STANDBY,
        error: undefined,
        total: 0,
        files: []
    }))(state);
};
exports.methods[listReducers.ActionTypes.FETCH_FAILURE] = (state, action) => fp.function.compose(data.set({
    status: FAILED,
    error: action.payload,
    total: 0,
    files: []
}), selectedItems.set([]))(state);
exports.methods[listReducers.ActionTypes.FETCH_SUCCESS] = (state, action) => {
    const files = action.payload.files;
    return fp.function.compose(fileBrowserLens.modify((x) => {
        if (!(0, exports.isDefaultSearch)(Object.assign(Object.assign({}, state.searchOptions), { toggleHideEmptyFolders: false }))) {
            return x;
        }
        return handleFileBrowser(x, action.payload.node, action.payload.files, action.payload.path, true);
    }), data.set({
        status: FETCHED,
        error: undefined,
        files: files,
        total: files.length
    }), currentFolder.set(action.payload.node), folderPath.set(action.payload.path))(state);
};
exports.methods[ActionTypes.SET_PAGING_OPTIONS] = (state, action) => {
    const { filters } = action.payload;
    if (filters) {
        Object.keys(filters).forEach((key) => filters[key] === null && delete filters[key]);
    }
    return Object.assign(Object.assign({}, state), { sortByOptions: Object.assign(Object.assign({}, action.payload), { filters }) });
};
exports.methods[ActionTypes.RESET_SORT_OPTIONS] = (state) => {
    const meta = state.metadata.status === 'FETCHED'
        ? state.metadata.list.find((x) => x.identifier === 'name-meta')
        : null;
    const sortBy = (meta && meta.id) || 0;
    return sortByOptions.set(Object.assign(Object.assign({}, exports.initialSortByOptions), { sortBy }))(state);
};
exports.methods[ActionTypes.RESET_SEARCH_OPTIONS] = (state) => {
    return fp.function.compose(searchDropdownToggledLens.set(false), advancedSearchDropdownToggledLens.set(false), searchOptions.set(Object.assign({}, exports.defaultFileSearchOptions)))(state);
};
exports.methods[quickSearchReducers.ActionTypes.FETCH_REQUEST] = (state, action) => {
    return searchDataLens.modify((x) => {
        if (x.status !== FETCHING) {
            return Object.assign(Object.assign({}, x), { error: undefined, status: FETCHING });
        }
        return x;
    })(state);
};
exports.methods[quickSearchReducers.ActionTypes.FETCH_SUCCESS] = (state, action) => {
    return searchDataLens.set({
        status: FETCHED,
        error: undefined,
        files: action.payload.files,
        total: action.payload.total
    })(state);
};
exports.methods[quickSearchReducers.ActionTypes.FETCH_FAILURE] = (state, action) => {
    return searchDataLens.set({
        status: FAILED,
        error: action.payload,
        files: [],
        total: 0
    })(state);
};
exports.methods[metaReducer.ActionTypes.FETCH_SCHEMA_REQUEST] = (state, action) => metadata.set({ status: 'FETCHING', list: [] })(state);
exports.methods[metaReducer.ActionTypes.FETCH_SCHEMA_SUCCESS] = (state, action) => {
    const metas = action.payload.metadata;
    const x = metas.find((x) => x.identifier === 'name-meta') || metas[0];
    return fp.function.compose(sortByOptions.set(Object.assign(Object.assign({}, exports.initialSortByOptions), { sortBy: (x && x.id) || 0 })), metadata.set({ status: 'FETCHED', list: action.payload.metadata }))(state);
};
exports.methods[metaReducer.ActionTypes.FETCH_SCHEMA_FAILURE] = (state, action) => metadata.set({ status: 'FAILURE', list: [] })(state);
exports.methods[ActionTypes.SELECT_ITEMS] = (state, action) => {
    return selectedItems.modify((xs) => action.data.items.reduce((acc, x) => {
        if (acc.findIndex((f) => f.uuid === x.uuid) === -1) {
            acc.push(x);
        }
        return acc;
    }, [...xs]))(state);
};
exports.methods[ActionTypes.UNSELECT_ITEMS] = (state, action) => {
    const items = [...state.selectedItems].reverse();
    for (let i = 0; i < action.data.items.length; i++) {
        const x = action.data.items[i];
        const idx = items.findIndex((f) => f.uuid === x.uuid);
        if (idx > -1) {
            items.splice(idx, 1);
        }
    }
    const modified = selectedItems.set(items)(state);
    return modified;
};
exports.methods[CartActionTypes.ADD_ITEMS] = (state, action) => {
    return selectedItems.set([])(state);
};
exports.methods[ActionTypes.SET_SEARCH_STRING] = (state, action) => {
    return searchStringLens.set(action.payload.searchString)(state);
};
exports.methods[ActionTypes.SET_CONTAINSTERM_STRING] = (state, action) => {
    return containsTermStringLens.set(action.payload.containsTermString)(state);
};
exports.methods[ActionTypes.SET_SEARCH_FILETYPE] = (state, action) => {
    if (action.payload.searchFileType.isSome() &&
        action.payload.searchFileType.value === 'FOLDER') {
        return fp.function.compose(containsTermStringLens.set(''), searchFileType.set(action.payload.searchFileType))(state);
    }
    else {
        return searchFileType.set(action.payload.searchFileType)(state);
    }
};
exports.methods[ActionTypes.TOGGLE_MORE_SEARCH] = (state, action) => {
    return fp.function.compose(limitSearchToFolder.modify((x) => (action.payload ? x : fp.option.none)), containsTermStringLens.modify((x) => (action.payload ? x : '')), searchMoreSearch.set(action.payload))(state);
};
exports.methods[ActionTypes.TOGGLE_FILTERS_DROPDOWN] = (state, action) => {
    return Object.assign(Object.assign({}, state), { filtersDropdownToggled: !state.filtersDropdownToggled });
};
exports.methods[ActionTypes.TOGGLE_COLUMNS_DROPDOWN] = (state, action) => {
    return Object.assign(Object.assign({}, state), { columnsDropdownToggled: !state.columnsDropdownToggled });
};
exports.methods[ActionTypes.TOGGLE_SORT_DROPDOWN] = (state, action) => {
    return Object.assign(Object.assign({}, state), { sortDropdownToggled: !state.sortDropdownToggled });
};
exports.methods[ActionTypes.TOGGLE_MOBILE_SEARCH_OVERLAY] = (state, action) => {
    return Object.assign(Object.assign({}, state), { mobileSearchOverlayToggled: !state.mobileSearchOverlayToggled });
};
exports.methods[ActionTypes.LIMIT_SEARCH_FOLDER_ID] = (state, action) => {
    return limitSearchToFolder.set(action.payload)(state);
};
exports.methods[ActionTypes.TOGGLE_SEARCH_DROPDOWN] = (state, action) => {
    const status = dataStatus.get(state);
    if (status === 'STANDBY') {
        return state;
    }
    return Object.assign(Object.assign({}, state), { searchDropdownToggled: !state.searchDropdownToggled });
};
exports.methods[ActionTypes.TOGGLE_ADVANCED_SEARCH_DROPDOWN] = (state, action) => {
    const status = dataStatus.get(state);
    if (status === 'STANDBY') {
        return state;
    }
    return Object.assign(Object.assign({}, state), { searchDropdownToggled: state.searchDropdownToggled && !state.advancedSearchDropdownToggled
            ? false
            : state.searchDropdownToggled, advancedSearchDropdownToggled: !state.advancedSearchDropdownToggled });
};
exports.methods[ActionTypes.BOOKMARK_FILE_SUCCESS] = (state, action) => state;
exports.methods[ActionTypes.UNBOOKMARK_FILE_SUCCESS] = (state, action) => state;
exports.methods[ActionTypes.BOOKMARK_FILE_REQUEST] = (state, action) => {
    const data = action.payload.id;
    return updateBookmark(state, data, true);
};
exports.methods[ActionTypes.UNBOOKMARK_FILE_REQUEST] = (state, action) => {
    const data = action.payload.id;
    return updateBookmark(state, data, false);
};
exports.methods[ActionTypes.OPEN_NOTIFICATIONS_OPTIONS_PANE] = (state, action) => {
    return notificationsOptionsOverlayStatus.set({
        type: Types.OPEN,
        files: action.payload.files.map((file) => (Object.assign({}, file))),
        projectName: action.payload.projectName,
        status: Types.STANDBY
    })(state);
};
exports.methods[ActionTypes.CLOSE_NOTIFICATIONS_OPTIONS_PANE] = (state, action) => {
    return notificationsOptionsOverlayStatus.set({
        type: Types.CLOSED
    })(state);
};
exports.methods[ActionTypes.TOGGLE_NOTIFICATIONS_REQUEST] = (state, action) => {
    const old = notificationsOptionsOverlayStatus.get(state);
    if (old.type === Types.OPEN) {
        return notificationsOptionsOverlayStatus.set({
            type: Types.OPEN,
            files: old.files,
            projectName: old.projectName,
            status: Types.SAVING
        })(state);
    }
    return state;
};
exports.methods[ActionTypes.TOGGLE_NOTIFICATIONS_FAILURE] = (state, action) => {
    const old = notificationsOptionsOverlayStatus.get(state);
    if (old.type === Types.OPEN) {
        return notificationsOptionsOverlayStatus.set({
            type: Types.OPEN,
            files: old.files,
            projectName: old.projectName,
            status: Types.FAILED
        })(state);
    }
    return state;
};
exports.methods[ActionTypes.TOGGLE_NOTIFICATIONS_SUCCESS] = (state, action) => {
    const old = notificationsOptionsOverlayStatus.get(state);
    if (old.type === Types.OPEN) {
        return notificationsOptionsOverlayStatus.set({
            type: Types.OPEN,
            files: old.files,
            projectName: old.projectName,
            status: Types.SAVED
        })(state);
    }
    return state;
};
exports.methods[ActionTypes.TOGGLE_FILE_REPORT_MODAL] = exports.methods[ActionTypes.TOGGLE_FILE_REPORT_SELECTION] = (state, action) => monocle.Lens.fromProp('fileReport').set(fileReportReducer.reducer(state.fileReport, action))(state);
exports.methods[ActionTypes.TOGGLE_PREVIEW_FILE_DROPDOWN] = (state, action) => {
    return Object.assign(Object.assign({}, state), { previewFileDropdownToggled: !state.previewFileDropdownToggled });
};
exports.methods[ActionTypes.SET_PREVIEW_FILE_DROPDOWN] = (state, action) => {
    return Object.assign(Object.assign({}, state), { previewFileDropdownToggled: action.flag });
};
exports.methods[ActionTypes.SET_PREVIEW_FULL_SCREEN_ENABLED] = (state, action) => {
    return Object.assign(Object.assign({}, state), { previewFullScreenEnabled: action.enabled });
};
exports.methods[ActionTypes.PREVIEW_FILE_REVISION] = (state, action) => {
    return previewFileRevision.set(action.revision)(state);
};
exports.methods[ActionTypes.COMPARE_FILE_REVISIONS] = (state, action) => {
    return fp.function.compose(previewFileRevision.set(action.revision), comparedFileRevision.set(action.comparedRevision))(state);
};
exports.methods[ActionTypes.SET_COMPARISION_OPACITY] = (state, action) => {
    return comparisionOpacity.set(action.opacity)(state);
};
exports.methods[ActionTypes.SET_COLUMN_FILTER_STRING] = (state, action) => {
    const filters = state.sortByOptions.filters
        ? Object.assign({}, state.sortByOptions.filters) : {};
    filters[action.payload.columnId] = action.payload.columnValue;
    return sortByOptionsFilter.set(filters)(state);
};
exports.methods[ActionTypes.CLEAR_COLUMN_FILTER] = (state, action) => {
    const newFilters = Object.assign({}, state.sortByOptions.filters);
    if (newFilters) {
        delete newFilters[action.columnId];
    }
    return sortByOptionsFilter.set(newFilters)(state);
};
exports.methods[ActionTypes.CLEAR_ALL_COLUMN_FILTERS] = (state, action) => {
    return fp.function.compose(searchOptions.set(exports.defaultFileSearchOptions), sortByOptions.set(exports.initialState.sortByOptions))(state);
};
exports.methods[ActionTypes.UPDATE_FOLDER_NOTIFICATIONS] = (state, action) => {
    const old = notificationsOptionsOverlayStatus.get(state);
    if (old.type !== 'CLOSED') {
        return notificationsOptionsOverlayStatus.set(Object.assign(Object.assign({}, old), { files: action.payload.files.map((file) => (Object.assign(Object.assign({}, file), { notifications: file.notifications
                    ? Object.assign(Object.assign({}, file.notifications), { email: action.payload.state, pushnotifications: false }) : undefined }))) }))(state);
    }
    return notificationsOptionsOverlayStatus.set(Object.assign({}, old))(state);
};
exports.methods[ActionTypes.RESET_SELECTED_FOLDERS] = (state, action) => {
    return selectedFolders.set([])(state);
};
exports.methods[ActionTypes.FETCH_FILELIST_COLUMNS_SUCCESS] = (state, action) => fileListLens.modify((s) => (Object.assign(Object.assign({}, s), { filteredMetadataColumns: action.metadatas })))(state);
exports.methods[ActionTypes.SET_FILTERING_TYPE] = (state, action) => {
    const filter = action.filtering;
    if (filter === 'BOOKMARKS') {
        return fp.function.compose(setFilteringLens.set(filter), toggleShowBookmarks.set(true), toggleRecents.set(false))(state);
    }
    else if (filter === 'RECENTS') {
        return fp.function.compose(setFilteringLens.set(filter), toggleRecents.set(true), toggleShowBookmarks.set(false))(state);
    }
    else {
        // assume NONE
        return fp.function.compose(setFilteringLens.set('NONE'), toggleRecents.set(false), toggleShowBookmarks.set(false))(state);
    }
};
exports.methods[ActionTypes.SET_HIDE_EMPTY_FOLDERS] = (state, action) => {
    return toggleHideEmptyFolders.set(action.payload.value)(state);
};
exports.methods[ActionTypes.CLEAR_SORT_BY_OPTIONS] = (state, action) => {
    return sortByOptions.set(exports.initialState.sortByOptions)(state);
};
exports.methods[FolderPermissionChecksActionTypes.CHECK_COPY_REQUEST] =
    exports.methods[FolderPermissionChecksActionTypes.CHECK_COPY_FAILED] =
        exports.methods[FolderPermissionChecksActionTypes.CHECK_COPY_SUCCESS] =
            exports.methods[FolderPermissionChecksActionTypes.CHECK_MOVE_REQUEST] =
                exports.methods[FolderPermissionChecksActionTypes.CHECK_MOVE_FAILED] =
                    exports.methods[FolderPermissionChecksActionTypes.CHECK_MOVE_SUCCESS] =
                        exports.methods[FolderPermissionChecksActionTypes.RESET_CHECKS] =
                            (state, action) => initialPermissionsStateLens.modify((s) => permissionReducers.reducer(s, action))(state);
exports.methods[ActionTypes.CLEAR] = (state, action) => {
    return Object.assign({}, exports.initialState);
};
exports.methods[ActionTypes.IMPORT_CLEAR] = (state, action) => {
    return Object.assign(Object.assign({}, state), { import: {
            currentStep: '1',
            step1: exports.initialState.import.step1,
            step2: exports.initialState.import.step2
        } });
};
exports.methods[ActionTypes.IMPORT_FETCH_PROJECT_LIST_REQUEST] = (state, action) => {
    return Object.assign(Object.assign({}, state), { import: Object.assign(Object.assign({}, state.import), { step1: Object.assign(Object.assign({}, state.import.step1), { projectList: [] }) }) });
};
exports.methods[ActionTypes.IMPORT_FETCH_PROJECT_LIST_SUCCESS] = (state, action) => {
    return Object.assign(Object.assign({}, state), { import: Object.assign(Object.assign({}, state.import), { step1: Object.assign(Object.assign({}, state.import.step1), { projectList: action.data }) }) });
};
exports.methods[ActionTypes.IMPORT_SET_PROJECT] = (state, action) => {
    return Object.assign(Object.assign({}, state), { import: Object.assign(Object.assign({}, state.import), { step1: Object.assign(Object.assign({}, state.import.step1), { project: action.data, files: Object.assign(Object.assign({}, importFromProjectReducer.initialState), { mode: state.import.step1.files.mode }) }), step2: exports.initialState.import.step2 }) });
};
exports.methods[ActionTypes.IMPORT_FETCH_GROUP_LIST_REQUEST] = (state, action) => {
    return Object.assign(Object.assign({}, state), { import: Object.assign(Object.assign({}, state.import), { step2: exports.initialState.import.step2 }) });
};
exports.methods[ActionTypes.IMPORT_FETCH_GROUP_LIST_SUCCESS] = (state, action) => {
    return Object.assign(Object.assign({}, state), { import: Object.assign(Object.assign({}, state.import), { step2: Object.assign(Object.assign({}, state.import.step2), { groupsList: action.data }) }) });
};
exports.methods[ActionTypes.IMPORT_SET_GROUP] = (state, action) => {
    return Object.assign(Object.assign({}, state), { import: Object.assign({}, state.import) });
};
exports.methods[ActionTypes.IMPORT_SET_STEP] = (state, action) => {
    return Object.assign(Object.assign({}, state), { import: Object.assign(Object.assign({}, state.import), { currentStep: action.data }) });
};
exports.methods[ActionTypes.SET_FILELIST_WIDTH] = (state, action) => fileBrowserLens.modify((s) => (Object.assign(Object.assign({}, s), { fileListWidth: action.payload.width, openStatus: action.payload.status })))(state);
exports.methods[ActionTypes.GET_FILELIST_WIDTH] = (state, action) => fileBrowserLens.modify((s) => (Object.assign(Object.assign({}, s), { widthStatus: FETCHING })))(state);
exports.methods[ActionTypes.GET_FILELIST_WIDTH_SUCCESS] = (state, action) => fileBrowserLens.modify((s) => (Object.assign(Object.assign({}, s), { fileListWidth: action.data.width, widthStatus: FETCHED, openStatus: action.data.status })))(state);
exports.methods[ActionTypes.INIT_FOLDER_TREE] = (state, action) => {
    if (!action.payload.useFolderTree) {
        return fileBrowserLens.set(Object.assign(Object.assign({}, fileBrowserInitState), { enabled: false }))(state);
    }
    if (state.fileBrowser.tree.data.tree) {
        return state;
    }
    const root = new Tree_1.Node(Object.assign(Object.assign({}, action.payload.node), { name: (0, translation_1.getLocalization)('components/folderTreeNew/rootFolder') }), 'NO_INHERIT_SELECTION');
    const tree = new Tree_1.Tree(root);
    root.setSelected(true);
    root.setExpanded(true);
    let queue = Object.assign({}, state.fileBrowser.queue);
    let lookup = {};
    lookup[action.payload.node.id] = root;
    // Fake "pointer" thanks javascript ;)
    const pointer = { queue, lookup };
    handleQueue(pointer, [action.payload.node.id], tree);
    queue = pointer.queue;
    lookup = pointer.lookup;
    return fileBrowserLens.modify((s) => (Object.assign(Object.assign({}, s), { enabled: true, queue,
        lookup, tree: Object.assign(Object.assign({}, s.tree), { target: root, data: Object.assign(Object.assign({}, s.tree.data), { root,
                tree }) }) })))(state);
};
exports.methods[ActionTypes.FILE_BROWSER_FETCH_ITEMS_SUCCESS] = (state, action) => fileBrowserLens.modify((s) => {
    if (!s.tree.data.tree) {
        return s;
    }
    const tree = s.tree.data.tree.clone();
    let lookup = Object.assign({}, state.fileBrowser.lookup);
    let target = s.tree.target;
    let desiredTarget = s.desiredTarget;
    let queue = action.payload.reduce((acc, item) => {
        const list = acc[item.parent] || [];
        list.push(item);
        acc[item.parent] = list;
        return acc;
    }, Object.assign({}, s.queue));
    const pointer = { queue, lookup };
    handleQueue(pointer, s.missingParents.reduce((acc, x) => acc.concat(x), []).map((x) => x.id), tree);
    queue = pointer.queue;
    lookup = pointer.lookup;
    if (s.desiredTarget !== null) {
        const newTarget = lookup[s.desiredTarget];
        if (newTarget) {
            if (s.tree.target) {
                s.tree.target.setSelected(false);
            }
            newTarget.setExpanded(true);
            newTarget.setSelected(true);
            target = newTarget;
            let x = newTarget;
            while (x) {
                x.setExpanded(true);
                const raw = x.getValue();
                x = raw.id !== raw.parent ? lookup[raw.parent] : undefined;
            }
            desiredTarget = null;
        }
    }
    return Object.assign(Object.assign({}, s), { missingParents: [], queue,
        lookup,
        desiredTarget, tree: Object.assign(Object.assign({}, s.tree), { target, data: Object.assign(Object.assign({}, s.tree.data), { tree }) }) });
})(state);
exports.methods[ActionTypes.COLLAPSE_ALL] = (state) => fileBrowserLens.compose(fileBrowserTreeLens).modify((x) => {
    if (x.data.tree) {
        const newTree = x.data.tree.clone();
        const path = state.folderPath;
        for (const fol of Object.values(state.fileBrowser.lookup)) {
            const id = fol.getValue().id;
            if (path.findIndex((x) => x.id === id) > -1) {
                continue;
            }
            fol.setExpanded(false);
        }
        return Object.assign(Object.assign({}, x), { data: Object.assign(Object.assign({}, x.data), { tree: newTree }) });
    }
    return x;
})(state);
exports.methods[ActionTypes.FolderBrowserActions.FETCH_TREE_SUCCESS] = (state, action) => fileBrowserLens.modify((x) => {
    if (action.data.node.type !== 'FOLDER') {
        return x;
    }
    return handleFileBrowser(x, action.data.node, action.data.files, action.data.path, false);
})(state);
const folderTreeMethods = Object.keys(folderTreeReducer.methods).reduce((prev, curr) => {
    prev[curr] = (state, action) => copyOrMoveLens.set(folderTreeReducer.reducer(state.copyOrMove, action))(state);
    return prev;
}, {});
const _folderBrowserMethods = folderBrowserReducer.methods;
delete folderBrowserReducer.methods[ActionTypes.FolderBrowserActions.FETCH_TREE_SUCCESS];
const folderBrowserMethods = Object.keys(_folderBrowserMethods).reduce((prev, curr) => {
    prev[curr] = (state, action) => fileBrowserLens
        .compose(fileBrowserTreeLens)
        .modify((s) => folderBrowserReducer.reducer(s, action))(state);
    return prev;
}, {});
const importFromProjectMethods = Object.keys(importFromProjectReducer.methods).reduce((prev, curr) => {
    prev[curr] = (state, action) => importLens
        .compose(importStep1Lens)
        .compose(importStep1FilesLens)
        .set(importFromProjectReducer.reducer(state.import.step1.files, action))(state);
    return prev;
}, {});
const propertiesMethods = Object.keys(propertiesReducer.methods).reduce((prev, curr) => {
    prev[curr] = (state, action) => propertiesLens.set(propertiesReducer.reducer(state.filesFolderProperties, action))(state);
    return prev;
}, {});
const previewMethods = Object.keys(previewReducer.methods).reduce((prev, curr) => {
    if (curr ===
        previewReducer.GeneratePreviewActionTypes.GENERATE_PREVIEW_REQUEST) {
        prev[curr] = (state, action) => {
            if (state.data.status === FETCHED) {
                const files = state.data.files.map((file, i) => {
                    if (file.uuid === action.payload && file.type !== 'FOLDER') {
                        const requestedFile = Object.assign(Object.assign({}, file), { preview: {
                                uuid: '',
                                status: 'PROCESSING'
                            } });
                        return requestedFile;
                    }
                    else {
                        return file;
                    }
                });
                return fp.function.compose((s) => (Object.assign(Object.assign({}, s), { data: Object.assign(Object.assign({}, s.data), { files }) })), monocle.Lens.fromProp('preview').set(previewReducer.reducer(state.preview, action)))(state);
            }
            return state;
        };
    }
    else if (curr ===
        previewReducer.GeneratePreviewActionTypes.GENERATE_PREVIEW_SUCCESS) {
        prev[curr] = (state, action) => {
            if (state.data.status === FETCHED) {
                const files = state.data.files.map((file, i) => {
                    if (file.type !== 'FOLDER' &&
                        file.uuid === action.data.revisionUuid) {
                        const processedFile = Object.assign(Object.assign({}, file), { preview: {
                                uuid: action.data.uuid,
                                status: action.data.status
                            } });
                        return processedFile;
                    }
                    else {
                        return file;
                    }
                });
                return fp.function.compose((s) => (Object.assign(Object.assign({}, s), { data: Object.assign(Object.assign({}, s.data), { files }) })), monocle.Lens.fromProp('preview').set(previewReducer.reducer(state.preview, action)))(state);
            }
            else {
                return state;
            }
        };
    }
    else if (curr ===
        previewReducer.GeneratePreviewActionTypes.GENERATE_PREVIEW_FAILURE) {
        prev[curr] = (state, action) => {
            if (state.data.status === FETCHED) {
                const files = state.data.files.map((file, i) => {
                    if (file.uuid === action.revisionUuid && file.type !== 'FOLDER') {
                        const failedFile = Object.assign(Object.assign({}, file), { preview: {
                                uuid: '',
                                status: 'FAILED'
                            } });
                        return failedFile;
                    }
                    else {
                        return file;
                    }
                });
                return fp.function.compose((s) => (Object.assign(Object.assign({}, s), { data: Object.assign(Object.assign({}, s.data), { files }) })), monocle.Lens.fromProp('preview').set(previewReducer.reducer(state.preview, action)))(state);
            }
            else {
                return state;
            }
        };
    }
    else {
        prev[curr] = (state, action) => monocle.Lens.fromProp('preview').set(previewReducer.reducer(state.preview, action))(state);
    }
    return prev;
}, {});
exports.methods[revisionActions.FETCH_REQUEST] =
    exports.methods[revisionActions.FETCH_FAILED] =
        exports.methods[revisionActions.FETCH_SUCCESS] =
            (state, action) => monocle.Lens.fromProp('preview').set(previewReducer.reducer(state.preview, action))(state);
exports.methods = Object.assign(Object.assign(Object.assign({}, exports.methods), automaticFileConversionReducer.methods), folderTreeMethods, importFromProjectMethods, propertiesMethods, previewMethods, folderBrowserMethods);
const files = (state = exports.initialState, action) => {
    if (exports.methods[action.type]) {
        return exports.methods[action.type](state, action);
    }
    return state;
};
exports.files = files;
//# sourceMappingURL=index.js.map